import { Session } from "types/Session";

import client from "./client";

interface SessionResponse {
  data: Session;
}

export const getSession = (sessionId: string, clientId: string, enablePayeeJourney?: boolean): Promise<SessionResponse> =>
  client.get(`/client/${clientId}/session/${sessionId}`);
